import { Component } from "@angular/core";

@Component({
  templateUrl: "./deploys-view.component.html",
})
export class DeploysViewComponent {}
